import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConsoleTile from 'components/shared/ConsoleTile/ConsoleTile';
import { DeviceChartView } from 'components/features/DeviceChartView';
import DeviceConfigTable from 'components/features/DeviceConfigTable/DeviceConfigTable';
import { MaintenancePanelBar } from 'components/features/MaintenancePanelBar/MaintenancePanelBar';
import AlarmTable from 'components/features/AlarmTable/AlarmTable';
import GA2RFControllerTable from '../GA2RFControllerTable/GA2RFControllerTable';
import {
  getSingleDevice,
  doFetchAlarms,
  storeAllDeviceAlarms,
  updatePivotOverviewPageSingleSelectedDevice,
  updateEchoOverviewPageSelectedDevice
} from 'redux/actions';
import { distillProductType } from 'common/utils/helpers';
import { Status } from 'common/utils/constants';
import RfController from 'components/features/RfController/RfController';
import classnames from 'classnames';

import './DeviceDetailsPanel.css';

const DeviceDetailsPanel = (props) => {
  const fetchAlarmsStatus = useSelector((store) => store.statuses.fetchAlarms);
  const statuses = useSelector((store) => store.statuses == null);
  const dispatch = useDispatch();
  const pollDeviceTimeout = useRef(null);
  const deviceId = props.isGa2
    ? props.donorDevice?.id || props.donorDevice?.deviceId
    : props.device?.id || props.device?.deviceId;
  const selectedDevice = useSelector((store) => {
    if (props.deviceType === 'pivot') {
      return store.ui.pivotOverviewPage.selectedDevices?.[deviceId];
    } else {
      return store.ui.echoOverviewPage.selectedDevice;
    }
  });

  const handleFetchAlarms = (deviceId) => {
    if (fetchAlarmsStatus == null && deviceId) {
      dispatch(
        doFetchAlarms(
          [deviceId], // deviceIDs,
          null,
          null,
          ['active'],
          null,
          null,
          1000,
          null,
          ['severity'],
          (result) => {
            dispatch(storeAllDeviceAlarms(result));
          },
          (error) => {
            console.log('doFetchAlarmsError', error);
          },
          []
        )
      );
    }
  };

  const handleGetSingleDevice = (deviceId) => {
    if (statuses['GET-' + deviceId] !== Status.PENDING) {
      dispatch(
        getSingleDevice(deviceId, (result) => {
          if (props.deviceType === 'echo') {
            dispatch(updateEchoOverviewPageSelectedDevice(result));
          } else {
            dispatch(updatePivotOverviewPageSingleSelectedDevice(result));
          }
        })
      );
    }
  };

  useEffect(() => {
    return () => {
      clearInterval(pollDeviceTimeout.current);
    };
  }, []);

  useEffect(() => {
    handleGetSingleDevice(deviceId);
    handleFetchAlarms(deviceId);

    //clear timer
    if (pollDeviceTimeout.current != null) clearInterval(pollDeviceTimeout.current);

    //and poll duh
    pollDeviceTimeout.current = setInterval(() => {
      handleGetSingleDevice(deviceId);
      handleFetchAlarms(deviceId);
    }, 15000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceId]);

  return (
    <div id="DeviceDetailsPanelContainer">
      <div className="DeviceDetailsPanel_MaintenanceBar_Div">
        <MaintenancePanelBar
          source={'details'}
          isGa2={props.isGa2}
          targetDevice={selectedDevice}
          targetDeviceType={
            distillProductType(selectedDevice?.properties?.reported?.productType) === 'subscriber'
              ? 'echo'
              : distillProductType(selectedDevice?.properties?.reported?.productType)
          }
        />
      </div>

      <div className="rowFlexDiv">
        <div
          className={classnames({
            DeviceDetailsPanel_AlarmTable_ContainerDiv: true,
            DeviceDetailsPanel_AlarmTable_ContainerDiv_GA1: !props.isGa2,
            DeviceDetailsPanel_AlarmTable_ContainerDiv_GA2: props.isGa2
          })}
        >
          <ConsoleTile title="Alarms" type="AlarmTable">
            <AlarmTable deviceID={deviceId} isGa2={props.isGa2} />
          </ConsoleTile>
        </div>

        <div className="DeviceDetailsPanel_RfController_Div">
          <ConsoleTile title="5G RF Configuration">
            {props.isGa2 ? (
              <GA2RFControllerTable device={selectedDevice} />
            ) : (
              <RfController device={selectedDevice} isGa2={props.isGa2} />
            )}
          </ConsoleTile>
        </div>
      </div>
      <div className="DeviceDetailsPanel_DeviceConfigTable_Div">
        <DeviceConfigTable
          device={selectedDevice}
          isGa2={props.isGa2}
          refreshDeviceData={() => handleGetSingleDevice(deviceId)}
        />
      </div>
      <div className="rowFlexDiv">
        <div style={{ flex: '1 1 0%', margin: '0px 0px 16px 0px', maxWidth: '100%' }}>
          <DeviceChartView deviceId={deviceId} />
        </div>
      </div>
    </div>
  );
};

export default DeviceDetailsPanel;
